import React from "react";
import { Box, Typography } from "@mui/material";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import useTranslation from "../../../../shared/hooks/useTranslation";
import { dt } from "../../../../shared/themes/redesignTokens";

interface DefaultIndicatorProps {
  fieldName: string;
  fieldsFromDefaults: Set<string>;
  /** For checkbox groups, pass a list of fields -- shows indicator if ANY are from defaults */
  groupFields?: string[];
  /** Custom label override */
  label?: string;
}

const DefaultIndicator = ({
  fieldName,
  fieldsFromDefaults,
  groupFields,
  label,
}: DefaultIndicatorProps) => {
  const { translate } = useTranslation(["serviceOffers"]);

  const isFromDefaults = groupFields
    ? groupFields.some((f) => fieldsFromDefaults.has(f))
    : fieldsFromDefaults.has(fieldName);

  if (!isFromDefaults) return null;

  return (
    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5, mt: 0.5 }}>
      <InfoOutlinedIcon sx={{ fontSize: 12, color: dt.textMuted }} />
      <Typography
        sx={{
          fontSize: 11,
          color: dt.textMuted,
          fontFamily: dt.font,
          lineHeight: 1.4,
        }}
      >
        {label || translate("fromPricingDefaults")}
      </Typography>
    </Box>
  );
};

export default DefaultIndicator;
